// src/config/whatsappConfig.js
export const phoneNumber = "+2399809666"; // Seu número de telefone com código do país, sem o "+"
export const message = "Olá, gostaria de mais informações sobre seus produtos."; // Mensagem opcional
